import styled from "styled-components"
import {
  BannerWrapperStyles,
  HeadingWrapperStyles,
  ButtonsWrapperStyles,
} from "./banner-styles"
import { BreakPoints, media } from "../../helpers/rwd"

interface IBannerWrapper {
  height: number
  width: number
  bgImg: string
}

export const BannerWrapper = styled.div<IBannerWrapper>`
  display: flex;
  flex-direction: column;
  height: ${props => `${props.height}px`};
  width: 100%;
  max-width: ${props => `${props.width}px`};
  justify-content: flex-end;
  background-image: url(${props => props.bgImg});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  & > a {
    display: block;
    width: 100%;
    height: 100%;
  }
  ${media.max(BreakPoints.desktop)} {
    max-height: 200px;
  }
  ${BannerWrapperStyles}
`

export const HeadingWrapper = styled.div`
  margin: 10px 20px;
  & > h4 {
    margin: 0;
  }
  ${HeadingWrapperStyles}
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  ${ButtonsWrapperStyles}
`
